import { FOREIGN_LINK_BORDER, FOREIGN_LINK_SIZE } from "../config";
import { TCanvasLink } from "../types/TCanvasLink";

export default function hoverAreaLink(
  link: TCanvasLink,
  color: string,
  ctx: CanvasRenderingContext2D,
) {
  if (link.link_type != "foreign") return;
  if (typeof link.source == "string"
    || typeof link.target == "string"
    || link.source.x == undefined
    || link.target.y == undefined
    || link.source.y == undefined
    || link.target.x == undefined
  ) return;
  let middle = {
    x: (link.source.x + link.target.x) / 2,
    y: (link.source.y + link.target.y) / 2
  }
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.arc(middle.x, middle.y,FOREIGN_LINK_SIZE + FOREIGN_LINK_BORDER, 0, 2 * Math.PI, false)
  ctx.fill()
}
